//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import  InTitle  from '../title'
import BScroll from 'better-scroll'
import MipLightbox from '@/components/clinicToast/mipLightbox'
import { InsurStore } from '../../store'

    export default {
        name:'mechanism',
        data() {
            return {
                // key: value
                bs :null,
                dataList : []
            }
        },
        components: {
            InTitle,
            MipLightbox
        },
        mounted() {
            this.init()
        },
        computed: {
            hospital() {
                return InsurStore.insurance.hospital
            },
            templateFlag(){
                return this.$route.query.templateFlag
            }
        },
        watch: {
            hospital(newValue, oldValue) {
                this.dataList = newValue.hospital_list
                this.init()
            }
        },
        created(){
            this.dataList = this.hospital.hospital_list
        },
        methods: {
            // 初始化BScroll
            init() {
                this.bs = new BScroll(this.$refs.scroll, {
                    startX: 0,
                    click: true,
                    scrollX: true,
                    scrollY: false,
                    eventPassthrough: "vertical"
                })
            },
            mapClick(item){
                this.STATISTICS_CONFIG.insur_proinfo_clinic_click()
                let hostPonit = {
                    lat: item.latitude,
                    lng: item.longitude
                }
                this.$refs.mipLightbox.showToast(hostPonit)
            },
            moreClick(){
                this.STATISTICS_CONFIG.insur_proinfo_allclinic_click()
                this.$refs.mipLightbox.showToast();
            }
        }
    }
